import { StateCreator } from 'zustand';
import { FreightMode, FreightCostInput, Accessorial } from '@freight-cbm/shared-types';

const MODE_DEFAULT_DIVISOR: Record<FreightMode, number> = {
  [FreightMode.Air]: 6000,
  [FreightMode.OceanLCL]: 1000,
  [FreightMode.Courier]: 5000,
};

export interface CalculationSlice {
  mode: FreightMode;
  dimDivisor: number;
  divisorOverridden: boolean;
  costInput: FreightCostInput;
  setMode: (mode: FreightMode) => void;
  setDimDivisor: (divisor: number) => void;
  resetDivisor: () => void;
  setRatePerKg: (rate: number) => void;
  setRatePerCBM: (rate: number) => void;
  setRatePerRevenueTon: (rate: number) => void;
  setRatePerContainer: (rate: number) => void;
  setAccessorials: (accessorials: Accessorial[]) => void;
  setCurrency: (currency: string) => void;
}

export const createCalculationSlice: StateCreator<CalculationSlice> = (set) => ({
  mode: FreightMode.Air,
  dimDivisor: 6000,
  divisorOverridden: false,
  costInput: {
    ratePerKg: 0,
    ratePerCBM: 0,
    ratePerRevenueTon: 0,
    ratePerContainer: 0,
    accessorials: [],
    currency: 'USD',
  },
  setMode: (mode) =>
    set({
      mode,
      dimDivisor: MODE_DEFAULT_DIVISOR[mode],
      divisorOverridden: false,
    }),
  setDimDivisor: (divisor) =>
    set({ dimDivisor: divisor, divisorOverridden: true }),
  resetDivisor: () =>
    set((state) => ({
      dimDivisor: MODE_DEFAULT_DIVISOR[state.mode],
      divisorOverridden: false,
    })),
  setRatePerKg: (rate) =>
    set((state) => ({
      costInput: { ...state.costInput, ratePerKg: rate },
    })),
  setRatePerCBM: (rate) =>
    set((state) => ({
      costInput: { ...state.costInput, ratePerCBM: rate },
    })),
  setRatePerRevenueTon: (rate) =>
    set((state) => ({
      costInput: { ...state.costInput, ratePerRevenueTon: rate },
    })),
  setRatePerContainer: (rate) =>
    set((state) => ({
      costInput: { ...state.costInput, ratePerContainer: rate },
    })),
  setAccessorials: (accessorials) =>
    set((state) => ({
      costInput: { ...state.costInput, accessorials },
    })),
  setCurrency: (currency) =>
    set((state) => ({
      costInput: { ...state.costInput, currency },
    })),
});
